import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const LEGAL = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Use',   path: '/terms' },
  { label: 'Disclosure',     path: '/disclosure' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.top}>
          {/* Brand col */}
          <div className={styles.brand}>
            <div className={styles.logo}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M21 3C21 3 12 3 7 8C2 13 3 21 3 21C3 21 11 22 16 17C21 12 21 3 21 3Z" fill="#B5D96A"/>
                <path d="M3 21L10 14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Movement<em>Green</em>
            </div>
            <p className={styles.tagline}>
              Helping Victorian homeowners access government rebates and upgrade to energy-efficient appliances under the Victorian Energy Upgrades program.<sup>*</sup>
            </p>
            <p className={styles.disclosure}>
              *Movement Green Pty Ltd is an Accredited Person under the Victorian Energy Upgrades (VEU) program, accredited by the Essential Services Commission (ESC) of Victoria. Rebate eligibility and amounts are subject to VEU program requirements.
            </p>
            <div className={styles.socials}>
              {['Twitter','LinkedIn','Instagram'].map(s => (
                <a key={s} href="#top" className={styles.social} aria-label={s}>
                  <svg width="14" height="14" viewBox="0 0 14 14"><circle cx="7" cy="7" r="3" fill="rgba(181,217,106,0.7)"/></svg>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <p className={styles.colHead}>Navigate</p>
            <div className={styles.links}>
              {[['Home','/'],['Solutions','/solutions'],['Impact','/impact'],['About','/about'],['Contact','/contact']].map(([l,p]) => (
                <Link key={p} to={p} className={styles.flink}>{l}</Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <p className={styles.colHead}>Legal</p>
            <div className={styles.links}>
              {LEGAL.map(({ label, path }) => (
                <Link key={path} to={path} className={styles.flink}>{label}</Link>
              ))}
            </div>
          </div>

          {/* Newsletter */}
          <div className={styles.newsletter}>
            <p className={styles.colHead}>Stay Updated</p>
            <p className={styles.nlDesc}>VEU rebate updates, new eligible products, and energy saving tips for Victorian homes.</p>
            {done ? (
              <p className={styles.nlDone}>✓ You're in the movement.</p>
            ) : (
              <form className={styles.nlForm} onSubmit={e => { e.preventDefault(); if(email.trim()) setDone(true); }}>
                <input type="email" required placeholder="Your email" value={email}
                  onChange={e => setEmail(e.target.value)} className={styles.nlInput} />
                <button type="submit" className={styles.nlBtn}>Join</button>
              </form>
            )}
          </div>
        </div>

        <div className={styles.divider}/>

        <div className={styles.bottom}>
          <span className={styles.copy}>© 2025 Movement Green. Delivering Victorian Energy Upgrades across Victoria.</span>
          {/* <div className={styles.bottomLinks}>
            {['Twitter','LinkedIn','Instagram'].map(s => (
              <a key={s} href="#top" className={styles.bottomLink}>{s}</a>
            ))}
          </div> */}
        </div>
      </div>
    </footer>
  );
}
